import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function ProjetESytel({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        A l'ère du numérique, nous sommes un petit groupe, passionnés par les
        développements dans les nouvelles technologies. Nous pourrions faire
        plusieurs propositions :
        <ul className="list-disc pl-12">
          <li>un site internet vitrine améliorant la communication externe</li>
          <li>
            intranet facilitant le partage de dossiers entre service et le
            transfert de compétences le télétravail (GED)
          </li>
          <li>
            espace collaboratif, interface pour une meilleure connaissance des
            salariés en interne facilitant le partage et la convivialité dans
            des activités extra professionnelles :
          </li>
        </ul>
        <ul className="list-disc pl-24">
          <li>la vie dans l'entreprise et dans la région</li>
          <li>
            les nouveaux arrivants, les départs, les naissances, les
            mariages,...
          </li>
          <li>
            les engagements associatifs, sportifs, culturels de nos collègues
          </li>
          <li>
            les offres du CE : voyages, billetteries, achats collectifs,
            prestations diverses...
          </li>
        </ul>
      </p>
      <p>
        Ce projet de création d'une page web « échanges personnels » ne pourra
        qu'amplifier la communication interne au sein de notre entreprise et
        développer le sentiment d'appartenance de chaque salarié.
      </p>
      <p>Toutes remarques de votre part seront les bienvenues</p>
      <p>
        Nous espérons sincèrement que notre projet puisse se concrétiser
        rapidement.
      </p>
      <p className="pt-4">
        {variablesData.employe_informatique_1_prenom}{" "}
        {variablesData.employe_informatique_1_nom},{" "}
        {variablesData.employe_informatique_2_prenom}{" "}
        {variablesData.employe_informatique_2_nom} et{" "}
        {variablesData.employe_informatique_3_prenom}{" "}
        {variablesData.employe_informatique_3_nom}
      </p>
      <MailSignature
        emetteurLogo={ProjetESytel.metadata.emetteurLogo}
        emetteur={ProjetESytel.metadata.emetteur}
        emetteurPoste={ProjetESytel.metadata.emetteurPoste}
        emetteurEntreprise={ProjetESytel.metadata.emetteurEntreprise}
      />
    </div>
  );
}

ProjetESytel.metadata = {
  titre: "Projet e-Sytel",
  cleMail: "projet_e_sytel",
  messageTransfert: false,
  emetteur: "Juliette BAUDRY",
  emetteurPoste: "",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -7,
  piecesJointes: [],
} as MailMetadata;

export default ProjetESytel;
